/**
 * auth.ts — авторизация (login / logout) через async fetch
 * Проект: TorgiRT (shared — все витрины)
 *
 * Заменяет synchronous XHR из старого zap.js на async fetch.
 * Импортирует только config.js (листовой модуль без зависимостей).
 */

import { getConfig } from './config';
import { showFlash } from './toast';

/* ── Валидация формы логина ── */

const RE_EMAIL = /^[-a-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)*(?:aero|arpa|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|[a-z][a-z])$/;
const RE_PASS = /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z]).{8,}$/;

/**
 * Валидация полей формы авторизации.
 */
export function validateLoginForm(
  email: string,
  password: string,
  acceptOferta: boolean,
  acceptPd: boolean
): string {
  const errors: string[] = [];
  if (!RE_EMAIL.test(email.toLowerCase())) {
    errors.push('* Введите правильный логин.');
  }
  if (!RE_PASS.test(password)) {
    errors.push('* Пароль должен состоять из восьми или более символов латинского алфавита, содержать заглавные и строчные буквы, цифры.');
  }
  if (!acceptOferta) {
    errors.push('* Примите оферту интернет-магазина.');
  }
  if (!acceptPd) {
    errors.push('* Дайте согласие на обработку персональных данных.');
  }
  return errors.join('\n');
}

/* ── Отправка формы авторизации / выхода ── */

/**
 * Отправка формы авторизации или выхода (async fetch).
 */
export async function submitAuthForm(formData: string, formName: string): Promise<void> {
  const routes: Record<string, string | undefined> = {
    b_aut:    getConfig('ajaxLoginUrl',  '/i/ajax/auth/login') as string,
    b_logout: getConfig('ajaxLogoutUrl', '/i/ajax/auth/logout') as string,
  };

  const url = routes[formName];
  if (!url) return;

  const csrfToken = getConfig('csrfToken', '') as string;
  const parts = ['perm=' + formName];
  if (formData) parts.push(formData);
  if (csrfToken) parts.push('csrf_token=' + encodeURIComponent(csrfToken));
  const body = parts.join('&');

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
      },
      body,
      credentials: 'same-origin',
    });

    if (!response.ok) {
      let errorMsg = 'Ошибка отправки запроса. Статус: ' + response.status;
      if (response.status === 404) {
        errorMsg = 'Ошибка: маршрут не найден. Проверьте путь: ' + url;
      } else if (response.status === 500) {
        errorMsg = 'Ошибка сервера. Проверьте логи PHP.';
      }
      showFlash(errorMsg, 'error');
      return;
    }

    const reak = await response.json();

    if (reak.deys === 'rel') {
      setTimeout(function () { document.location.reload(); }, 100);
      return;
    }

    if (reak.deys === 'mes') {
      const msg = String(reak.mesage ?? '');
      const variant = reak.col === 'green' ? 'success' : 'error';
      showFlash(msg, variant);
    }
  } catch (e: any) {
    console.error('submitAuthForm: ошибка:', e);
    showFlash('Ошибка при отправке запроса: ' + e.message, 'error');
  }
}
